import api from "../config/apiConfig";
import { getSelectedCompany } from "../utils/auth";
import { getRegisterId } from "../utils/authId";
import { toast } from "react-toastify";

export const ProfileDetails = async () => {
  const regId = getRegisterId();

  try {
    const response = await api.get(
      `api/get_profile_details/?register_id=${regId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Edit Update

export const EditProfile = async (id, update) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...update,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(`api/update_employee/${id}/`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Updated successful!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
